(function () {
  'use strict';
  function initPlpSizeToggle() {
    if (window._plpSizeToggleInitialized) return;
    window._plpSizeToggleInitialized = true;
    document.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest('.plp-card-size-toggle');
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();
        var card =
          toggleBtn.closest('.card') ||
          toggleBtn.closest('.card-wrapper') ||
          toggleBtn.closest('.product-card-wrapper');
        if (!card) return;
        var isCurrentlyOpen = card.classList.contains('is-sizes-open');
        document.querySelectorAll('.is-sizes-open').forEach(function (openCard) {
          if (openCard !== card) {
            openCard.classList.remove('is-sizes-open');
            var otherBtn = openCard.querySelector('.plp-card-size-toggle');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          }
        });
        if (isCurrentlyOpen) {
          card.classList.remove('is-sizes-open');
          toggleBtn.setAttribute('aria-expanded', 'false');
        } else {
          card.classList.add('is-sizes-open');
          toggleBtn.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      if (
        !e.target.closest('.card') &&
        !e.target.closest('.card-wrapper') &&
        !e.target.closest('.product-card-wrapper')
      ) {
        document.querySelectorAll('.is-sizes-open').forEach(function (openCard) {
          openCard.classList.remove('is-sizes-open');
          var btn = openCard.querySelector('.plp-card-size-toggle');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var toggleBtn = e.target.closest('.plp-card-size-toggle');
        if (toggleBtn) {
          e.preventDefault();
          toggleBtn.click();
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlpSizeToggle);
  } else {
    initPlpSizeToggle();
  }
})();
